import { useMutation } from '@apollo/client/react';
import { SEND_REQUESTS_MUTATION } from './useSendRequests.gql';
export const useSendRequests = () => {
  const [sendRequestsMutation] = useMutation(SEND_REQUESTS_MUTATION);

  return (requestIds: string[], generateLocally: boolean) =>
    sendRequestsMutation({
      variables: {
        requestIds: requestIds,
        generateLocally: generateLocally,
      },
    });
};
